import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'

import { UntilDestroy } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { take } from 'rxjs/operators'
import { Location } from 'src/app/features/location/location'
import { locationSelectors } from 'src/app/features/location/location.selectors'
import { Member } from 'src/app/features/member/member'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { Organization } from 'src/app/features/organization/organization'
import { organizationSelectors } from 'src/app/features/organization/organization.selectors'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { SerieProposal, SerieProposalStatus } from '../serie-proposal'
import { SerieProposalItemStatus } from '../serie-proposal-item/serie-proposal-item'
import { SerieProposalService } from '../serie-proposal.service'

@UntilDestroy()
@Component({
  selector: 'serie-proposal-initial-request-modal',
  templateUrl: './initial-request-modal.component.html',
  styleUrls: ['./initial-request-modal.component.scss']
})
export class SerieProposalInitialRequestModalComponent implements OnInit {
  @Input() serieProposal: SerieProposal

  public productEntities$: Observable<Dictionary<Product>>
  public locationEntities$: Observable<Dictionary<Location>>
  public memberEntities$: Observable<Dictionary<Member>>
  public organizationEntities$: Observable<Dictionary<Organization>>
  public selectedLanguage$: Observable<string>
  public serieProposalItemStatus = SerieProposalItemStatus
  public productEntities: Dictionary<Product>
  public serieProposalStatus = SerieProposalStatus
  public activeTab: string = 'general'

  constructor(
    private store: Store<AppState>,
    public serieProposalService: SerieProposalService,
    private bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )

    this.locationEntities$ = this.store.select(locationSelectors.selectEntities)
    this.memberEntities$ = this.store.select(memberSelectors.selectEntities)
    this.productEntities$ = this.store.select(productSelectors.selectEntities)

    this.productEntities$
      .pipe(take(1))
      .subscribe((productEntites) => (this.productEntities = productEntites))

    this.locationEntities$ = this.store.select(locationSelectors.selectEntities)
    this.organizationEntities$ = this.store.select(
      organizationSelectors.selectEntities
    )
  }

  public cancel() {
    this.bsModalRef.hide()
  }
}
